import React from 'react';

class Toast extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      messages: []
    };

    this.success.bind(this);
    this.danger.bind(this);
    this.warning.bind(this);
    this.info.bind(this);
    window.Toast = this;
  }

  success(text) {
    this.alert("success", text);
  }

  danger(text) {
    this.alert("danger", text);
  }

  warning(text) {
    this.alert("warning", text);
  }

  info(text) {
    this.alert("info", text);
  }

  alert(type, text) {
    const messages = this.state.messages;
    messages.push({ type, text, timestamp: new Date().getTime() });
    this.setState({ messages });
  }

  componentDidMount() {
    const INTERVAL = 500 * 1;
    const DELAY = 250;

    window.setInterval(() => {
      const nowDateTime = new Date().getTime();
      const messages = this.state.messages;
      if (!messages.length) return;
      const newMessages = messages
        .filter(item => item.timestamp + INTERVAL > nowDateTime)
        .map(item => {
          item.fadeout = (item.timestamp + INTERVAL - nowDateTime) <= DELAY;
          return item;
        });

      this.setState({ messages: newMessages });
    }, DELAY);
  }

  render() {
    return (
      <>
        {this.state.messages.length > 0 && (
          <div className="toast-block" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }}>
            <div
              className={"toast-wrapper"}
              style={{ position: "absolute", padding: 0 }}>
              {this.state.messages.map((item, index) => (
                <div key={index} className={`alert alert-${item.type || "info"} ${item.fadeout ? "fade-out" : ""}`} role="alert">
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  }
}

export { Toast };
